'use client';

import { PlotlyChart } from './PlotlyChart';
import { LATENCY_THRESHOLDS, type MetricsSample } from '../types';
import { sortPods } from '../ChartContext';
import type { Layout } from 'plotly.js';

interface Props { samples: MetricsSample[]; loading?: boolean }

export function LatencyChart({ samples, loading }: Props) {
  const pods = sortPods(Array.from(new Set(samples.map((s) => s.pod))));
  const byPod = new Map<string, { x: Date[]; y: number[] }>();
  for (const pod of pods) byPod.set(pod, { x: [], y: [] });
  for (const s of [...samples].sort((a, b) => a.ts_ms - b.ts_ms)) {
    const v = s.server_latency >= 0 ? s.server_latency : null;
    if (v == null) continue;
    const series = byPod.get(s.pod);
    if (!series) continue;
    series.x.push(new Date(s.ts_ms));
    series.y.push(v);
  }

  const traces = pods.map((pod) => {
    const series = byPod.get(pod)!;
    return {
      x: series.x,
      y: series.y,
      type: 'scatter' as const,
      mode: 'lines' as const,
      name: pod,
      connectgaps: false,
    };
  });

  const shapes: Layout['shapes'] = LATENCY_THRESHOLDS.map((t) => ({
    type: 'line',
    x0: 0, x1: 1, xref: 'paper',
    y0: t.value, y1: t.value,
    line: { color: t.color, width: 1, dash: 'dot' },
  }));

  return <PlotlyChart traces={traces} yTitle="ms" shapes={shapes} loading={loading} />;
}
